
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guide7njzR6tgV2k_45cFWMcYoPf9lB0JqhjB0mPCnrEzdcekUMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/guide.vue?macro=true";
import { default as indexEfRj2gkGEDGaUxEx1jbXDiuijF3hbfF_t2BIwIPPwXUMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/index.vue?macro=true";
import { default as find_45replay8lakSigGtce0t32KEA_WGoZnr0gF9MUrAWcjUlbciI8Meta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/find-replay.vue?macro=true";
import { default as _91id_93Zg1SRq2TT7A6qZHghKQzvh8ru8gxlH74TGFmJP_45XJXkMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/replay/[id].vue?macro=true";
import { default as _91id_93yhQLjdpPfTqELhU4sqljXTGXJi03kMOlgRhdTWghlUgMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/account/[id].vue?macro=true";
import { default as _91id_93UDsHFDKmOF5fz2eLABLNYUafahXNAXk4gPE0rXEWaSYMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/contest/[id].vue?macro=true";
import { default as index_j90bRoAGQ_453mPTyJBndf70WFiM_B_KCMPdGvPf4ygsMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/contest/index.vue?macro=true";
import { default as uploadivnrNh67h_45eLRGgzqdw0e5sFcDJAOc87UyZ7NM55VJAMeta } from "/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/replay/upload.vue?macro=true";
export default [
  {
    name: "guide",
    path: "/guide",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/index.vue")
  },
  {
    name: "find-replay",
    path: "/find-replay",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/find-replay.vue")
  },
  {
    name: "replay-id",
    path: "/replay/:id()",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/replay/[id].vue")
  },
  {
    name: "account-id",
    path: "/account/:id()",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/account/[id].vue")
  },
  {
    name: "contest-id",
    path: "/contest/:id()",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/contest/[id].vue")
  },
  {
    name: "contest",
    path: "/contest",
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/contest/index.vue")
  },
  {
    name: "replay-upload",
    path: "/replay/upload",
    meta: {"middleware":"auth"},
    component: () => import("/builds/web/REPLAYS_PORTAL/mk_replays/frontend/pages/replay/upload.vue")
  }
]